module.exports = __webpack_public_path__ + "img/default-img1.d7ac7de2.png";